<template>
    <div class='binding'>
        <div class="binding-title">{{$t('login.editPwd.title')}}</div>

        <v-form
            @submit.native.prevent
            v-model="valid"
            class="mb-6"
            ref="bindingForm">
            <v-text-field
                v-model="formData.password"
                :rules="rules.password"
                outlined
                hide-details="auto"
                required
                min-height="46"
                color="#5066e0"
                class="mb-9 input-h-md"
                :error-messages="errorMessage"
                :type="isPasswordVisible ? 'text' : 'password'"
                :append-icon="isPasswordVisible ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                @click:append="isPasswordVisible = !isPasswordVisible"
                :placeholder="$t('login.passwordPlaceholder')"
            ></v-text-field>

            <v-text-field
                v-model="formData.affirmPassword"
                :rules="rules.affirmPassword"
                outlined
                hide-details="auto"
                required
                min-height="46"
                color="#5066e0"
                class="mb-8 input-h-md"
                :type="isPasswordVisible2 ? 'text' : 'password'"
                :append-icon="isPasswordVisible2 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                @click:append="isPasswordVisible2 = !isPasswordVisible2"
                :placeholder="$t('pwd.affirmPassword')"
            ></v-text-field>

            <v-btn color="primary" min-height="50" class="btn-box w-full" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
        </v-form>
    </div>
</template>

<script>
import { updatePwd } from "@/api/index";
import { getCookie, setCookie, delCookie } from '@/utils/cookie'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import store from '@/store'
let self;
export default {
    data() {
        let validatePass2 = (value) => {
            if (value === '') {
                return this.$t('pwd.affirmPassword')
            } else if (value !== this.formData.password) {
                return this.$t('pwd.verifyPassword')
            } else {
                return true
            }
        };
        return {
            formData: {},
            rules: {
                password: [
                    v => !!v || this.$t('pwd.newPwd'),
                    // { required: true, message: this.$t('pwd.newPwd'), trigger: 'blur' },
                    // { required: true,validator: this.validatePass,trigger: 'blur' }
                ],
                affirmPassword: [
                    v => !!v || this.$t('pwd.affirmPassword'),
                    v => validatePass2(v)
                ],
            },
            isPasswordVisible2: false,
            isPasswordVisible: false,
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline
            },
            valid: false,
            errorMessage: undefined
        };
    },
    props: {
        editToken: String
    },
    created() {
         self = this
    },
    watch: {
        'formData.password': (val,old) => {
            if(val) {
                self.validatePass(val)
            }
        },
    },
    methods: {
        onSubmit() {
            if (this.$refs.bindingForm.validate()) {
                let self = this
                this.$passwordEncryption(self.formData.password).then(password=> {
                    let params = {
                        newPwd: password,
                        updatePwdToken: self.editToken
                    }
                    console.log(self.formData.password)
                    let username = getCookie('username')
                    delCookie('username')
                    updatePwd(params).then(res=> {
                        if(res.code == self.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            self.$emit("editSubmit")
                        } else {
                            setCookie('username', username)
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    })
                })
            } else {
                return false;
            }
        },
        validatePass(value) {
            let uesename = getCookie("username")
            this.$checkNotLoginPassword(value,uesename,2).then(res => {
                console.log(value,uesename,2)
                this.errorMessage = res
            })
        },
    },
}
</script>

<style lang='scss' scoped>
.binding {
    min-width: 365px;
    // padding-top:8%;
    // margin-left: 250px;
    // margin-right: -85px;
    z-index: 15;
    .form-box ::v-deep {
        padding: 50px 0;
        .ant-form-item {
            margin-bottom: 30px;
        }
        .ant-input {
            font-size: 16px;
            height: 46px;
            border-radius: 10px;
            padding-left: 20px;
        }
        .ant-input:focus {
            box-shadow:none;
        }
        .btn-box {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: #5066e0;
            box-shadow: 0px 0px 10px 1px rgba(0, 80, 179, 0.2);
            border-radius: 10px;
            font-size: 18px;
            font-weight: 500;
            color: #FFFEFE;
            margin-top: 30px;
        }
    }
    .ant-input-password ::v-deep {
        .ant-input-suffix {
            right: 20px;
        }
    }
}
.binding-title {
    height: 70px;
    line-height: 70px;
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 50px;
    // opacity: 0.9;
}
</style>
